import { render, staticRenderFns } from "./FavoritesIcon.vue?vue&type=template&id=5ece11f3&"
import script from "./FavoritesIcon.vue?vue&type=script&lang=js&"
export * from "./FavoritesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports